import FlatButton from './FlatButton'
import RaisedButton from './Raised'

const Button = {
    FlatButton,
    Raised: RaisedButton
}

export default Button